import { useTranslation } from "react-i18next";

const cardOriginOperationOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "domestic",
      title: t("options.cardOriginOperation.domestic"),
      value: "DOMESTIC",
    },
    {
      key: "foreign",
      title: t("options.cardOriginOperation.foreign"),
      value: "FOREIGN",
    },
    {
      key: "unknown",
      title: t("options.cardOriginOperation.unknown"),
      value: "UNKNOWN",
    },
    {
      key: "n.a",
      title: t("options.cardOriginOperation.n.a"),
      value: "N/A",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default cardOriginOperationOptions;
